import { FileCheck2 } from "lucide-react";
import { euro } from "@/lib/format";

const stato = (f) => (f.saldata ? `saldata · ${euro(f.incassato)}`
  : f.rate ? `${f.rate_pagate} rate su ${f.rate} pagate · ${euro(f.incassato)} su ${euro(f.totale)}`
    : `da pagare · ${euro(f.totale)}`);

// Fatture legate al cantiere (dal preventivo o scelte a mano) con quanto è già stato pagato.
export const FattureCollegate = ({ fatture = [], testid = "cantiere-linked-invoices" }) => (
  <div className="space-y-1" data-testid={testid}>
    {fatture.map((f) => (
      <div key={f.id} className="flex items-center gap-2 text-sm" data-testid={`${testid}-${f.numero}`}>
        <FileCheck2 className={`w-4 h-4 shrink-0 ${f.saldata ? "text-emerald-600" : "text-muted-foreground"}`} />
        <span className="font-medium">Fattura N. {f.numero}</span>
        <span className="text-muted-foreground truncate">{stato(f)}</span>
      </div>
    ))}
  </div>
);

export const LinkInfo = ({ l }) => (
  <div className="sm:col-span-2 rounded-lg border border-emerald-200 bg-emerald-50/70 dark:bg-emerald-950/30 dark:border-emerald-900 px-3 py-2.5 space-y-2" data-testid="cantiere-link-info">
    <div className="flex flex-wrap gap-x-5 gap-y-1 text-sm">
      <span>Totale lavori <b data-testid="cantiere-link-total">{euro(l.totale)}</b></span>
      <span>Già incassato <b className="text-emerald-700 dark:text-emerald-400" data-testid="cantiere-link-paid">{euro(l.incassato)}</b></span>
      <span>Da incassare <b data-testid="cantiere-link-due">{euro(l.da_incassare)}</b></span>
    </div>
    {l.fatture.length ? <FattureCollegate fatture={l.fatture} testid="cantiere-link-invoices" />
      : <div className="text-xs text-muted-foreground">Nessuna fattura ancora emessa: i pagamenti compariranno qui appena li segni sulla fattura.</div>}
  </div>
);

export default FattureCollegate;
